/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ServerMessages = defineMessages({
  noVariablesInvalidUrl: {
    id: 'CatalogOpenApi.ServerMessages.noVariablesInvalidUrl',
    defaultMessage:
      'Invalid generated URL. Your uploaded OpenAPI specification is missing server variables:'
  },
  invalidUrl: {
    id: 'CatalogOpenApi.ServerMessages.invalidUrl',
    defaultMessage:
      'Please update server variables to create a valid generated URL:'
  },
  validUrl: {
    id: 'CatalogOpenApi.ServerMessages.validUrl',
    defaultMessage: 'Generated URL:'
  },
  servers: {
    id: 'CatalogOpenApi.ServerMessages.servers',
    defaultMessage: 'Servers'
  },
  serverVariables: {
    id: 'CatalogOpenApi.ServerMessages.serverVariables',
    defaultMessage: 'Server variables'
  },
  serverVariablesDescription: {
    id: 'CatalogOpenApi.ServerMessages.serverVariablesDescription',
    defaultMessage:
      'Enter values for your server variables to create a valid generated URL for requests.'
  }
});
